import React from 'react';
import { PlusCircle } from '@olxbr/ds-icons';
export const Desapegar = ({ active }) => (React.createElement("span", { "aria-hidden": "true", className: `navbar-desapegar-wrapper ${active ? 'active' : ''}`, "data-testid": "icon-desapegar" },
    React.createElement(PlusCircle, null)));
